import { render, staticRenderFns } from "./searchPopPGIS.vue?vue&type=template&id=cc7336cc&scoped=true&"
import script from "./searchPopPGIS.vue?vue&type=script&lang=ts&"
export * from "./searchPopPGIS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7336cc",
  null
  
)

export default component.exports